import { useState, useEffect, useCallback, useMemo } from "react"
import { type AppBackground, type GlassTokens, getAppBackground, setAppBackground as setStorage, APP_BG_CHANGE_EVENT, APP_GLASS_TOKENS } from "./appBackground"

export function useAppBackground(): [AppBackground, (value: AppBackground) => void] {
  const [value, setValue] = useState(getAppBackground)

  useEffect(() => {
    const handler = () => setValue(getAppBackground())
    window.addEventListener(APP_BG_CHANGE_EVENT, handler)
    return () => window.removeEventListener(APP_BG_CHANGE_EVENT, handler)
  }, [])

  const set = useCallback((v: AppBackground) => {
    setStorage(v)
    setValue(getAppBackground())
  }, [])

  return [value, set]
}

export function useGlassTokens(): GlassTokens {
  const [bg] = useAppBackground()
  return useMemo(() => APP_GLASS_TOKENS[bg], [bg])
}
